export default __webpack_public_path__ + "2a5b991d68095eaedb2871a905cd2b1b.svg";